import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Column, Row } from '~/commonComponents';
import { SolidStarIcon } from '@tempmee/react-icons';

interface IRatingBreakdownProps {
  professionalSkills: number;
  interpersonalSkills: number;
  timeManagement: number;
}

const SKILL_CATEGORIES = [
  { key: 'professionalSkills', label: 'Professional Skills' },
  { key: 'interpersonalSkills', label: 'Interpersonal Skills' },
  { key: 'timeManagement', label: 'Time Management' },
] as const;

export const RatingBreakdown = ({
  professionalSkills,
  interpersonalSkills,
  timeManagement,
}: IRatingBreakdownProps) => {
  const values = { professionalSkills, interpersonalSkills, timeManagement };

  return (
    <Column gap={8} paddingVertical={8} paddingLeft={60} paddingRight={32}>
      <Typography as="span" bold size="body_large" color={colors.neutral[600]}>
        Average Rating
      </Typography>
      {SKILL_CATEGORIES.map(({ key, label }) => (
        <Row key={key} alignItems="center" justifyContent="space-between">
          <Typography as="span" size="body_large" color={colors.neutral[600]}>
            {label}
          </Typography>
          <Row alignItems="center" gap={4}>
            {Array.from({ length: 5 }).map((_, i) => (
              <SolidStarIcon
                key={`${key}-star-${i}`}
                size={16}
                color={i < Math.floor(values[key]) ? colors.success[400] : colors.neutral[200]}
              />
            ))}
            <Typography as="span" size="body_large" color={colors.neutral[600]}>
              {values[key].toFixed(1)}
            </Typography>
          </Row>
        </Row>
      ))}
    </Column>
  );
};
